export default __webpack_public_path__ + "static/media/gg_navy-logo_stacked.a9a1b213.jpg";